import { ENABLED_LANGUAGES } from '~~/core';
import { useGlobalConfigurationAsyncData } from '~~/domains/graphql';

function normalizePath(path: string) {
  return path.length > 1 ? path.replace(/\/+$/, '') : path;
}

export default defineNuxtRouteMiddleware(async to => {
  const localePrefix = ENABLED_LANGUAGES.find(
    locale => to.path === `/${locale}` || to.path.startsWith(`/${locale}/`),
  );
  const path = localePrefix
    ? to.path.slice(localePrefix.length + 1) || '/'
    : to.path;
  const { data } = await useGlobalConfigurationAsyncData();

  if (!data.value?.globalConfiguration?.redirectConfigs?.length) {
    return;
  }

  const redirect = data.value?.globalConfiguration?.redirectConfigs.find(
    config =>
      normalizePath(config.redirectFrom) === normalizePath(to.path) ||
      normalizePath(config.redirectFrom) === normalizePath(path),
  );
  const destination = redirect?.redirectTo?.trim();
  if (!destination?.startsWith('/') || destination.startsWith('//')) {
    return;
  }

  const destinationHasLocale = ENABLED_LANGUAGES.some(
    locale =>
      destination === `/${locale}` || destination.startsWith(`/${locale}/`),
  );
  const localizedDestination =
    localePrefix && !destinationHasLocale
      ? `/${localePrefix}${destination}`
      : destination;

  if (
    normalizePath(localizedDestination.split(/[?#]/, 1)[0]) !==
    normalizePath(to.path)
  ) {
    return navigateTo(localizedDestination, { redirectCode: 301 });
  }
});
